import formChildrenProfile from "./components/form-children-profile";
import formParentProfile from "./components/form-parent-profile";
import formMainProfile from "./components/form-main-profile";
import formOrder from "./components/form-order";
import formQuizStart from "./components/form-quiz-start";
import formRequests from "./components/form-requests";
import formRegister from "./components/form-register";
import formShop from "./components/form-shop";
import {initCustomSelect, initDateInput, initPhoneInput} from "./lib/forms";

// forEach polyfill
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (var i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

// closest polyfill
(function (ELEMENT) {
	ELEMENT.matches = ELEMENT.matches || ELEMENT.mozMatchesSelector || ELEMENT.msMatchesSelector || ELEMENT.oMatchesSelector || ELEMENT.webkitMatchesSelector;
	ELEMENT.closest = ELEMENT.closest || function closest(selector) {
		if (!this) return null;
		if (this.matches(selector)) return this;
		if (!this.parentElement) {
			return null
		} else return this.parentElement.closest(selector)
	};
}(Element.prototype));

const DESKTOP_WIDTH = 1336;
const MOBILE_WIDTH = 768;

// Accordion
(function () {
	const initAccordion = (root) => {
		const toggleButton = root.querySelector(`.js-accordion-button`);
		const accordionOuter = root.querySelector(`.accordion__outer`);
		const accordionInner = root.querySelector(`.accordion__inner`);

		const updateHeight = () => {
			accordionOuter.style.maxHeight = `${accordionInner.offsetHeight}px`;
		};

		toggleButton?.addEventListener(`click`, (evt) => {
			evt.preventDefault();

			if (root.classList.contains(`accordion--active`)) {
				root.classList.remove(`accordion--active`);
				accordionOuter.removeAttribute(`style`);
			} else {
				root.classList.add(`accordion--active`);
				updateHeight();
			}
		});

		window.addEventListener(`resize`, () => {
			if (root.classList.contains(`accordion--active`)) {
				updateHeight();
			}
		});
	};

	window.accordion = {
		init: initAccordion,
	};
})();

// Phone inputs
const phoneInputs = document.querySelectorAll(`.js-phone-mask`);
phoneInputs.forEach(initPhoneInput);

// Date inputs
const dateInputs = document.querySelectorAll(`.js-date-mask`);
dateInputs.forEach(initDateInput);

// Custom select
document.querySelectorAll(`.js-select`).forEach(initCustomSelect);

// Sticky header
(function () {
	const HEADER_STICKY_POINT = 200;
	const header = document.querySelector(`.header`);

	if (header) {
		const headerWrapper = header.querySelector(`.header__inner`);
		let headerState = `static`;
		const setStatic = () => {
			header.classList.remove(`header--sticky`);
			header.classList.remove(`header--slide-header`);
			header.removeAttribute(`style`);
			headerState = `static`;
		};

		const setSticky = () => {
			const headerWrapperHeight = headerWrapper.offsetHeight;
			header.classList.add(`header--sticky`);
			header.classList.add(`header--slide-header`);
			header.style.paddingTop = `${headerWrapperHeight}px`;
			headerState = `sticky`;
		}

		const updateStickyHeader = () => {
			if (headerState == `static` && window.pageYOffset > HEADER_STICKY_POINT) {
				setSticky();
			}
			if (headerState == `sticky` && window.pageYOffset <= HEADER_STICKY_POINT) {
				setStatic();
			}
		};

		window.addEventListener(`scroll`, () => {
			updateStickyHeader();
		});

		window.addEventListener(`resize`, () => {
			updateStickyHeader();
		});
	}
})();

// Header menu
const body = document.querySelector(`body`);
const menu = document.querySelector(`.slide-menu`);

if (menu) {
	const menuButton = menu.querySelector(`.js-toggle-menu`);
	const menuAccordions = menu.querySelectorAll(`.accordion`);

	menuButton?.addEventListener(`click`, (evt) => {
		evt.preventDefault();

		menuButton.classList.toggle(`slide-menu__button--close`);
		menu.classList.toggle(`slide-menu--open`);
		body.classList.toggle(`body--slide-menu-open`);

		if (!menu.classList.contains(`slide-menu--open`)) {
			menuAccordions.forEach((accordion) => {
				const accordionOuter = accordion.querySelector(`.accordion__outer`);

				accordion.classList.remove(`accordion--active`);
				accordionOuter.removeAttribute(`style`);
			});
		}
	});
}

// Mobile navigation
(function () {
	const initMenuAccordion = (root) => {
		const accordionItems = root.querySelectorAll(`.accordion`);

		accordionItems.forEach((item) => {
			const toggleButton = item.querySelector(`.js-accordion-button`);
			const accordionOuter = item.querySelector(`.accordion__outer`);
			const accordionInner = item.querySelector(`.accordion__inner`);
			const closeButton = item.querySelector(`.js-close-submenu`);

			const updateHeight = () => {
				accordionOuter.style.maxHeight = `${accordionInner.offsetHeight}px`;
			};

			toggleButton?.addEventListener(`click`, (evt) => {
				evt.preventDefault();
				const currentActive = item.classList.contains(`accordion--active`);

				accordionItems.forEach((accordion) => {
					const accordionOuter = accordion.querySelector(`.accordion__outer`);
					accordion.classList.remove(`accordion--active`);
					accordionOuter.removeAttribute(`style`);
				});

				if (!currentActive) {
					item.classList.add(`accordion--active`);
					updateHeight();
				}
			});

			closeButton?.addEventListener(`click`, (evt) => {
				evt.preventDefault();
				item.classList.remove(`accordion--active`);
				accordionOuter.removeAttribute(`style`);
			});

			window.addEventListener(`resize`, () => {
				if (item.classList.contains(`accordion--active`)) {
					updateHeight();
				}
			});
		});
	};

	window.menuAccordion = {
		init: initMenuAccordion,
	};
})();

const slideNav = document.querySelector(`.slide-nav`);
if (slideNav) {
	window.menuAccordion.init(slideNav);
}

const additionalMenu = document.querySelector(`.additional-menu`);
if (additionalMenu) {
	window.menuAccordion.init(additionalMenu);
}

// Card link slider
(function () {
	const cardLinks = document.querySelectorAll(`.card-links`);

	cardLinks.forEach((slider) => {
		const cardLinksSlider = slider.querySelector(`.swiper`);
		let cardLinksSwiper;
		const initSwiper = () => {
			if (cardLinksSwiper) {
				return;
			}

			cardLinksSwiper = new Swiper(cardLinksSlider, {
				slidesPerView: 1.5,
				spaceBetween: 20,
				keyboardControl: true,
			});
		};

		const destroySwiper = () => {
			if (cardLinksSwiper) {
				cardLinksSwiper.destroy(true, true);
				cardLinksSwiper = undefined;
			}
		};

		const setSwiper = () => {
			if (window.innerWidth < MOBILE_WIDTH) {
				initSwiper();
			} else {
				destroySwiper();
			}
		};

		window.addEventListener(`resize`, setSwiper);
		setSwiper();
	});
})();

// News slider
(function () {
	const newsSliders = document.querySelectorAll(`.news-slider`);

	newsSliders.forEach((slider) => {
		const newsSlider = slider.querySelector(`.swiper`);

		const buttonNext = slider.querySelector(`.swiper-button-next`);
		const buttonPrev = slider.querySelector(`.swiper-button-prev`);

		const newsSwiper = new Swiper(newsSlider, {
			slidesPerView: 1.2,
			spaceBetween: 20,

			navigation: {
				nextEl: buttonNext,
				prevEl: buttonPrev,
			},

			breakpoints: {
				768: {
					slidesPerView: 2.28,
					spaceBetween: 24,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 28,
				},
				1336: {
					slidesPerView: 4,
					spaceBetween: 28,
				},
			}
		});
	});
})();

// Partners slider
(function () {
	const partnersSliders = document.querySelectorAll(`.partners-slider`);

	partnersSliders.forEach((slider) => {
		const partnerSlider = slider.querySelector(`.swiper`);

		const buttonNext = slider.querySelector(`.swiper-button-next`);
		const buttonPrev = slider.querySelector(`.swiper-button-prev`);

		const partnerSwiper = new Swiper(partnerSlider, {
			slidesPerView: `auto`,
			spaceBetween: 16,
			loop: true,

			navigation: {
				nextEl: buttonNext,
				prevEl: buttonPrev,
			},

			breakpoints: {
				768: {
					spaceBetween: 24,
				},
				1024: {
					spaceBetween: 28,
				},
			}
		});
	});
})();

// Camp sessions slider
(function () {
	const campSessionsSliders = document.querySelectorAll(`.camp-sessions__slider.swiper`);

	campSessionsSliders.forEach((slider) => {
		const campSessionSwiper = new Swiper(slider, {
			slidesPerView: 1.2,
			spaceBetween: 20,

			breakpoints: {
				768: {
					slidesPerView: 1.142,
					spaceBetween: 24,
				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 28,
				},
			}
		});
	});
})();

// Banners slider
(function () {
	const bannerSliders = document.querySelectorAll(`.slider-banners`);

	bannerSliders.forEach((root) => {
		const bannerSlider = root.querySelector(`.swiper`);

		const buttonNext = root.querySelector(`.swiper-button-next`);
		const buttonPrev = root.querySelector(`.swiper-button-prev`);
		const pagination = root.querySelector(`.swiper-pagination`);

		const campSessionSwiper = new Swiper(bannerSlider, {
			slidesPerView: 1,
			spaceBetween: 20,

			navigation: {
				nextEl: buttonNext,
				prevEl: buttonPrev,
			},

			pagination: {
				el: pagination,
				clickable: true,
			},

			breakpoints: {
				768: {
					spaceBetween: 24,
				},
				1336: {
					spaceBetween: 28,
				},
			}
		});
	});
})();

// Common slider
(function () {
	const commonSliders = document.querySelectorAll(`.common-slider`);

	commonSliders.forEach((root) => {
		const mainSlider = root.querySelector(`.common-slider__main.swiper`);
		const previewSlider = root.querySelector(`.common-slider__preview.swiper`);
		const buttonNext = root.querySelector(`.swiper-button-next`);
		const buttonPrev = root.querySelector(`.swiper-button-prev`);

		const previewSwiper = new Swiper(previewSlider, {
			slidesPerView: 3,
			spaceBetween: 12,
			breakpoints: {
				768: {
					spaceBetween: 28,
				}
			}
		});

		const mainSwiper = new Swiper(mainSlider, {
			slidesPerView: 1,
			spaceBetween: 12,
			navigation: {
				nextEl: buttonNext,
				prevEl: buttonPrev,
			},
			thumbs: {
				swiper: previewSwiper,
			},
			breakpoints: {
				768: {
					spaceBetween: 28,
				}
			}
		});
	});
})();

// Review slider
(function () {
	const reviewSliders = document.querySelectorAll(`.about__slider`);

	reviewSliders.forEach((root) => {
		const buttonNext = root.querySelector(`.swiper-button-next`);
		const buttonPrev = root.querySelector(`.swiper-button-prev`);

		const mainSwiper = new Swiper(root, {
			slidesPerView: 1.1,
			spaceBetween: 12,
			navigation: {
				nextEl: buttonNext,
				prevEl: buttonPrev,
			},
			breakpoints: {
				768: {
					slidesPerView: 1,
					spaceBetween: 28,
				}
			}
		});
	});
})();

// FAQ accordion
const faqAccordions = document.querySelectorAll(`.faq__list > .accordion`);

faqAccordions.forEach((accordion) => {
	window.accordion.init(accordion);
});

// Common accordion
const commonAccordions = document.querySelectorAll(`.accordion-section__list > .accordion`);

commonAccordions.forEach((accordion) => {
	window.accordion.init(accordion);
});

// Modal window
window.modalWindow = new HystModal({
	linkAttributeName: "data-hystmodal",
	catchFocus: false,
});

// Request modal
const requestModal = document.querySelector(`#request-modal`);

if (requestModal) {
	const requestModalForm = requestModal.querySelector(`#request-modal-form`);
	const requestModalTitle = requestModal.querySelector(`.modal__title`);
	const closeModalButton = requestModal.querySelector(`.js-close-modal`);
	const modalOverlay = requestModal.querySelector(`.hystmodal__shadow`);

	const resetForm = (evt) => {
		evt.preventDefault();
		requestModal.classList.remove(`modal--success-submit`);
		requestModal.classList.remove(`modal--error-submit`);
		if (requestModalTitle) {
			requestModalTitle.textContent = `Задать вопрос`;
		}
	};

	closeModalButton?.addEventListener(`click`, resetForm);
	modalOverlay?.addEventListener(`click`, resetForm);
	document.addEventListener(`keydown`, (evt) => {
		if (evt.key === `Escape`) {
			resetForm(evt);
		}
	});

	/*
	requestModalForm?.addEventListener(`submit`, (evt) => {
		evt.preventDefault();

		fetch(evt.target.action, {
			method: `POST`,
			body: new FormData(this)
		}).then(function (response) {
			if (response.ok) {
				requestModal.classList.add(`modal--success-submit`);
				if (requestModalTitle) {
					requestModalTitle.textContent = `Спасибо за обращение!`;
				}
			}
			return response.text();
		}).catch(function (error) {
			requestModal.classList.add(`modal--error-submit`);
			if (requestModalTitle) {
				requestModalTitle.textContent = `Произошла ошибка, попробуйте еще раз`;
			}
		});
	});
	 */
}

// Feedback form
const feedbackBlock = document.querySelector(`.feedback`);

if (feedbackBlock) {
	const feedbackForm = feedbackBlock.querySelector(`#feedback-form`);
	const feedbackResult = feedbackBlock.querySelector(`.feedback__submit-result`);

	feedbackForm?.addEventListener(`submit`, (evt) => {
		evt.preventDefault();

		fetch(evt.target.action, {
			method: `POST`,
			body: new FormData(this)
		}).then(function (response) {
			if (response.ok) {
				feedbackBlock.classList.add(`feedback--success-submit`);
				if (feedbackResult) {
					feedbackResult.textContent = `Спасибо за обращение!`;
				}
			}
			return response.text();
		}).catch(function (error) {
			feedbackBlock.classList.add(`feedback--error-submit`);
			if (feedbackResult) {
				feedbackResult.textContent = `Произошла ошибка, попробуйте еще раз`;
			}
		});
	});
}

// Tooltips
function initTooltips() {
	const tooltips = document.querySelectorAll(`.tooltip`);

	tooltips.forEach((tooltip) => {
		const tooltipOpenButton = tooltip.querySelector(`.tooltip__button`);
		const tooltipTemplate = tooltip.querySelector(`.tooltip__template`);

		const tooltipPopup = tippy(tooltipOpenButton, {
			content: tooltipTemplate.innerHTML,
			allowHTML: true,
			interactive: true,
			arrow: false,
			appendTo: document.body,
			maxWidth: 370,
		});

		tooltipOpenButton.addEventListener(`click`, (evt) => {
			const tippyBox = document.querySelector(`.tippy-box`);
			const tooltipCloseButton = tippyBox.querySelector(`.tooltip__close-button`);


			tooltipCloseButton?.addEventListener(`click`, (evt) => {
				evt.preventDefault();
				tooltipPopup.hide();
			});
		});
	});
}

initTooltips();

// Heading tags slider
(function () {
	const TABLET_LANDSCAPE_WIDTH = 1024;
	const headingTagsSlider = document.querySelector(`.heading__submenu`);

	if (headingTagsSlider) {
		let headingTagsSwiper;
		const initSwiper = () => {
			if (headingTagsSwiper) {
				return;
			}

			headingTagsSwiper = new Swiper(headingTagsSlider, {
				slidesPerView: `auto`,
				spaceBetween: 8,
				loop: false,
				freeMode: true,
			});
		};

		const destroySwiper = () => {
			if (headingTagsSwiper) {
				headingTagsSwiper.destroy(true, true);
				headingTagsSwiper = undefined;
			}
		};

		const setSwiper = () => {
			if (window.innerWidth < TABLET_LANDSCAPE_WIDTH) {
				initSwiper();
			} else {
				destroySwiper();
			}
		};

		window.addEventListener(`resize`, setSwiper);
		setSwiper();
	}
})();

// Dropdown menu
const dropdownMenu = document.querySelector(`.dropdown-menu`);

if (dropdownMenu) {
	const dropdownButton = dropdownMenu.querySelector(`.js-dropdown-button`);

	dropdownButton?.addEventListener(`click`, (evt) => {
		evt.preventDefault();
		dropdownMenu.classList.toggle(`dropdown-menu--open`);
	});

	document.addEventListener(`click`, (evt) => {
		const isClickInside = dropdownMenu.contains(evt.target);

		if (!isClickInside) {
			dropdownMenu.classList.remove(`dropdown-menu--open`);
		}
	});
}

// Dropdown profile menu
const profileMenu = document.querySelector(`.profile-nav`);

if (profileMenu) {
	const dropdownButton = profileMenu.querySelector(`.js-profile-nav-button`);

	dropdownButton?.addEventListener(`click`, (evt) => {
		evt.preventDefault();
		profileMenu.classList.toggle(`profile-nav--open`);
	});

	document.addEventListener(`click`, (evt) => {
		const isClickInside = profileMenu.contains(evt.target);

		if (!isClickInside) {
			profileMenu.classList.remove(`profile-nav--open`);
		}
	});
}

// Hide password
const passwordFields = document.querySelectorAll(`.form__field--password`);

passwordFields.forEach((field) => {
	const input = field.querySelector(`.form__input`);
	const button = field.querySelector(`.js-hide-password`);
	let isPassword = true;

	button.addEventListener(`click`, (evt) => {
		evt.preventDefault();

		if (isPassword) {
			input.type = `text`;
			isPassword = false;
			field.classList.add(`form__field--password-shown`);
		} else {
			input.type = `password`;
			isPassword = true;
			field.classList.remove(`form__field--password-shown`);
		}
	});
});

// Registration form
const registrationForm = document.querySelector(`#registration-form`);

if (registrationForm) {
	const dateSection = registrationForm.querySelector(`.form__fieldset--date`);
	const timeSection = registrationForm.querySelector(`.form__fieldset--time`);
	const contactsSection = registrationForm.querySelector(`.form__fieldset--contacts`);
	const formBottom = registrationForm.querySelector(`.form__bottom`);

	if (dateSection) {
		const dateInputs = dateSection.querySelectorAll(`.form__input`);

		dateInputs.forEach((dateInput) => {
			dateInput.addEventListener(`change`, () => {
				if (timeSection) {
					timeSection.classList.add(`form__fieldset--shown`);

					const timeInputs = timeSection.querySelectorAll(`.form__input`);

					timeInputs.forEach((timeInput) => {
						timeInput.addEventListener(`change`, () => {
							if (contactsSection) {
								contactsSection.classList.add(`form__fieldset--shown`);
								formBottom?.classList.add(`form__bottom--shown`);
							}
						});
					});
				}
			});
		});
	}

	registrationForm.addEventListener(`submit`, (evt) => {
		evt.preventDefault();

		fetch(evt.target.action, {
			method: `POST`,
			body: new FormData(this)
		}).then(function (response) {
			if (response.ok) {
				registrationForm.classList.add(`form--submit-success`);
			}
			return response.text();
		})
	});
}

// Gallery
const galleriesItems = document.querySelectorAll(`.galleries__item`);

galleriesItems.forEach((item) => {
	const galleryId = item.dataset.galleryId;

	Fancybox.bind(`[data-fancybox="${galleryId}"]`, {
		Toolbar: false,
		Thumbs: false,
		closeButton: true,
	});
});

// Video
Fancybox.bind(`.news-card--video[data-fancybox]`, {
	Toolbar: false,
	Thumbs: false,
	closeButton: true,
	mainClass: "video-digest__popup",
	Html: {
		iframeAttr: {
			allow: "clipboard-write; autoplay",
			frameBorder: "0",
			webkitAllowFullScreen: "webkitAllowFullScreen",
			mozallowfullscreen: "mozallowfullscreen",
			allowFullScreen: "allowFullScreen"
		},
	},
});


// Show more
const requisitesSection = document.querySelector(`.requisites`);

if (requisitesSection) {
	const showMoreButton = requisitesSection.querySelector(`.js-show-more-button`);

	showMoreButton?.addEventListener(`click`, (evt) => {
		evt.preventDefault();
		requisitesSection.classList.toggle(`requisites--list-open`);
		if (requisitesSection.classList.contains(`requisites--list-open`)) {
			showMoreButton.textContent = `Скрыть`;
		} else {
			showMoreButton.textContent = `Раскрыть полностью`;
		}
	});
}

$(function () {
	$(document).on('click', '[data-open-person]', function () {
		$.ajax({
			url: '/local/ajax/personInfo.php',
			dataType: "html",
			data: {
				elementId: $(this).attr('data-open-person'),
				iblockId: $(this).attr('data-iblock'),
			},
			type: "POST",
			success: function (data) {
				$('#person-modal .person-detail').html($(data).html());
				modalWindow.open('#person-modal');
			},
		});
		return false;
	})
})

/*Опросник*/

const quizControl = {
	setTab: function (i) {
		if ($('[data-tab-pagen=' + i + ']').length > 0) {
			$('[data-tab-pagen]').removeClass('questionnaire__pagination-item--current');
			$('[data-tab-pagen=' + i + ']').addClass('questionnaire__pagination-item--current');
			$('[data-question-tab]').addClass('hidden');
			$('[data-question-tab=' + i + ']').removeClass('hidden');
		}
	},
	setNextTab: function () {
		let currentTab = this.getCurrentTab();
		this.setTab(currentTab + 1);
	},
	setPrevTab: function () {
		let currentTab = this.getCurrentTab();
		let prevTab = currentTab - 1;
		if (prevTab > 0) {
			this.setTab(prevTab);
		}
	},
	getCurrentTab: function () {
		return $('.questionnaire__pagination-item--current').data('tab-pagen');
	}
}
$(document).on('click', '[data-tab-pagen]', function () {
	const i = $(this).data('tab-pagen');
	quizControl.setTab(i);
})
$(document).on('click', '[data-next-question]', function () {
	quizControl.setNextTab();
})
$(document).on('click', '[data-prev-question]', function () {
	quizControl.setPrevTab();
})
$(document).on('mouseenter','.footer-nav__list .footer-nav__item',function () {
	let $this = $(this);
	$this.closest('.footer-nav__list').find('.footer-nav__item').removeClass('active');
	$this.addClass('active')
})


const initComponents = () => {
	formChildrenProfile.init();
	formParentProfile.init();
	formMainProfile.init();
	formQuizStart.init();
	formRequests.init();
	formRegister.init();
	formShop.init();
};

if (document.readyState === "loading") {
	// Loading hasn't finished yet
	document.addEventListener("DOMContentLoaded", initComponents);
} else {
	// `DOMContentLoaded` has already fired
	initComponents();
}

export {
	formOrder,
	initTooltips
};